{
  "planGen": {
    "preparingContext": "Preparing plan generation context...",
    "generatingStructure": "Generating plan structure...",
    "refiningExecSummary": "Refining plan structure (executive summary classification)...",
    "enrichmentComplete": "Enrichment complete — assembling plan...",
    "reviewingAlignment": "Reviewing plan alignment…",
    "applyingTemplate": "Applying template formatting…",
    "savingTemplate": "Saving template…",
    "finalizing": "Finalizing plan structure...",
    "foundSections": "Found {{count}} sections",
    "enrichingDetails": "Enriching section details ({{done}}/{{total}} calls done)",
    "enrichingStart": "Enriching {{count}} sections across {{agents}} parallel calls...",
    "rateLimited": "Rate limited — retrying in {{seconds}}s (attempt {{attempt}}/{{max}})...",
    "enrichBatchFailed": "Enrichment batch {{batch}} of {{total}} failed — continuing.",
    "complete": "Plan generation complete",
    "connectionInterrupted": "Connection interrupted — checking progress...",
    "readingInputs": "Reading your task description and template...",
    "extractingConstraints": "Extracting requirements and constraints...",
    "retrievingKnowledge": "Retrieving methodology and domain knowledge...",
    "discoveringTools": "Identifying available analysis tools...",
    "elapsedOfBudget": "{{elapsed}}s elapsed of a {{budget}}s budget"
  },
  "contentGen": {
    "preparingContext": "Preparing context: {{title}}",
    "generatingContent": "Generating content: {{title}}",
    "contentWrittenVerbatim": "Section '{{title}}' content written (verbatim)",
    "contentGenerated": "Section '{{title}}' content generated"
  },
  "sectionRegen": {
    "starting": "Starting regeneration...",
    "refiringExecSummary": "Refiring executive summary...",
    "retrievingContext": "Retrieving context...",
    "contextReady": "Context ready",
    "generating": "Generating content...",
    "finalizing": "Finalizing..."
  },
  "sectionGen": {
    "allGenerated": "All sections generated. Starting holistic cross-section consistency check.",
    "holisticWaiting": "Holistic self-check waiting on {{count}} failed section(s). Retry them to continue.",
    "normalizingInconsistencies": "Normalizing {{count}} cross-section inconsistencies.",
    "holisticComplete": "Holistic self-check complete. Sections ready for review.",
    "generatingExecSummary": "Generating executive summary from self-checked report content."
  }
}
